import React from 'react';
import type { PullPanelExtrasProps } from '../../types';
import { NotionFilterBuilder } from './NotionFilterBuilder';

const NotionPullPanelExtras: React.FC<PullPanelExtrasProps> = ({
  provider,
  formValues,
  selectedObject,
  onChange,
  disabled,
  nodeData,
}) => {
  if (provider !== 'notion' || selectedObject !== 'database_records') return null;

  const databaseId = formValues.database as string | undefined;
  const filterValue = formValues.notionFilter as
    | { and?: Array<{ property: string; propertyType: string; operator: string; value: unknown }> }
    | Array<{ property: string; propertyType: string; operator: string; value: unknown }>
    | undefined;

  const handleFilterChange = (value: unknown) => {
    onChange?.('notionFilter', value);
  };

  return (
    <NotionFilterBuilder
      databaseId={databaseId ?? ''}
      value={filterValue}
      onChange={handleFilterChange}
      disabled={disabled}
      nodeData={nodeData}
    />
  );
};

export default NotionPullPanelExtras;
